import React, { useLayoutEffect, useRef } from 'react';

import LoadFailed from '../shared/load_failed';
import { is_focus_lost } from '../shared/dialog_logic';
import { readiness_showing_text } from './adapters';

// the teacher search and the paging line shared by the close and reopen dialogs.

const SEARCH_ERROR_ID = 'tp-teacher-search-error';

// error: too-long message, shown by the field; the search is not sent while it stands. input_ref:
// the dialog's focus target when the list's "Try again" unmounts.
export const TeacherSearch = ({ value, on_change, error = '', input_ref = null }) => (
  <div className="flex flex-col gap-1">
    <input
      ref={input_ref}
      className="tp-input"
      type="search"
      value={value}
      onChange={(e) => on_change(e.target.value)}
      placeholder="Search by teacher name or email"
      aria-label="Search teachers by name or email"
      aria-invalid={error ? 'true' : undefined}
      aria-describedby={error ? SEARCH_ERROR_ID : undefined}
    />
    {error ? (
      <span id={SEARCH_ERROR_ID} className="tp-neg" role="alert">
        {error}
      </span>
    ) : null}
  </div>
);

export const MORE_LOAD_FAILED_TEXT = 'Could not load more teachers.';

/*
 * "Load more" stays focusable while it loads (aria-disabled, not disabled, which would drop
 * focus).
 */
export const ReadinessPager = ({ list, loading_more, more_failed, on_more, on_retry }) => {
  const more_ref = useRef(null);
  const showing_ref = useRef(null);
  const show_more = list.has_more && !more_failed;
  const controls = `${show_more}|${more_failed}`;
  const prev_controls = useRef(controls);
  useLayoutEffect(() => {
    const changed = prev_controls.current !== controls;
    prev_controls.current = controls;
    if (!changed || !is_focus_lost(document.activeElement, document.body)) return;
    const target = more_ref.current || showing_ref.current;
    if (target) target.focus({ preventScroll: true });
  }, [controls]);

  return (
    <div className="tp-frow">
      <span className="tp-card-hd-sub" tabIndex={-1} ref={showing_ref}>
        {readiness_showing_text(list)}
      </span>
      {show_more ? (
        <button
          type="button"
          className="tp-btn-ghost"
          ref={more_ref}
          onClick={loading_more ? undefined : on_more}
          aria-disabled={loading_more ? 'true' : undefined}
        >
          {loading_more ? 'Loading…' : 'Load more'}
        </button>
      ) : null}
      {more_failed ? <LoadFailed text={MORE_LOAD_FAILED_TEXT} on_retry={on_retry} /> : null}
    </div>
  );
};
